




















import { Vue, Component, Prop } from "vue-property-decorator";

import Message from "../../chat/models/Messages/Message";
import { process } from '../../../common/MessageProcessor';
import ContactsShareAtachments from "../../chat/components/chat/atachments/ContactsShareAtachments.vue";
import AttachmentsTypes from "../../chat/enums/AttachmentsTypes";
import { parseJson } from "@common/TypesHelper";
import { CommentAttachment } from "@api/enums/CommentTypes";

@Component({
    components: { ContactsShareAtachments }
})
export default class ChatExportMessage extends Vue {
    @Prop({required: true}) message: Message;
    @Prop({required: true}) name: string;
    @Prop({ default: 'light' }) theme: string;

    get contacts() {
        return this.attachments?.filter(item => item.type == AttachmentsTypes.contacts) || [];
    }

    get attachments(): CommentAttachment[] | undefined {
        return parseJson(this.message.attachments)
    }

    get time() {
        return this.message.createdAt.toFormat('T')
    }

    get computedName() {
        return this.$store.state.session.userId === this.message.userID ? this.$t("common.you") : this.name;
    }

    get isMy() {
        return this.message.userID == this.$store.state.session.userId;
    }

    get hasAttachments() {
        return this.contacts?.length > 0;
    }

    get preparedMessage() {
        const result = this.message.message || '';
        return process(result, ['img', 'a'], true);
    }
}
